import React from "react";
import { Bookings } from "../../components";

export default function Home() {
  return (
    <div>
      <Bookings />
    </div>
  );
}
